// extracted by mini-css-extract-plugin
export default {"grid":"classCompact_grid__lacn5","dots":"classCompact_dots__Tt0a3","selected":"classCompact_selected__rReNS"};